import React, { useEffect, useState } from "react"
import { startLoader, stopLoader } from "../../lib/global";
import { useDispatch } from "react-redux";
import { getAllMerchantList } from "../../redux/actions/merchant-center.action";
import InputField from "../../components/formControl/input/InputField";


const ListMerchant = (props) => {
    const [merchantData, setMerchantData] = useState([]);
    const dispatch = useDispatch();
    const [filter, setFilter] = useState('');
    const filterData = {
        limit: 9999,
        offset: 0,
    };

    const apiData = (filter) => {
        startLoader();
        const response = dispatch(getAllMerchantList(filter));
        response.then((data) => {
            if (data && data.data && data.data.status === 200) {
                setMerchantData(data && data.data && data.data.data);
            }
        })
        .catch((error) => console.error(error));
        stopLoader();
    };
    useEffect(() => {
        apiData(filterData)
    }, []);

    const chat = (data) => {
        props.onSubmit(data)
        props.onClose()
    }

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };

    const filteredData = merchantData.filter((item) =>
        item.merchantName.toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <React.Fragment>
            <div className="align-items-center justify-content-between px-3">
                <div className="py-2">
                    <InputField
                        className=""
                        formClass="col-12"
                        type="text"
                        id="search"
                        placeholder="Search"
                        name="search"
                        value={filter}
                        onChange={handleFilterChange}
                    />
                </div>
                <div className="border card rounded-lg position-relative" style={{ maxHeight: "60vh", overflow: "auto" }}>
                    <table className="table border-0">
                        <thead className="position-sticky">
                            <th>Name</th>
                            <th>Action</th>
                        </thead>
                        <tbody>
                            {filteredData && filteredData.length > 0 && filteredData.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{item.preferredMerchantName != ''?item.preferredMerchantName:item.merchantname}</td>
                                        <td>
                                            <button className="btn btn-sm btn-primary" onClick={(e)=>chat(item)}>Chat</button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ListMerchant